// src/styles/GlobalStyles.js
// Styles CSS globaux injectés dans le <head>.

import { C, FONTS } from './theme';

export function GlobalStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;1,400&display=swap');

      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; -webkit-tap-highlight-color: transparent; }
      html, body, #root      { height: 100%; background: ${C.bg}; font-family: ${FONTS.body}; color: ${C.text}; overscroll-behavior: none; }
      button, input          { font-family: ${FONTS.body}; outline: none; }
      ::-webkit-scrollbar    { display: none; }
      *                      { scrollbar-width: none; }

      @keyframes fadeIn  { from { opacity:0; transform:translateY(10px) } to { opacity:1; transform:translateY(0) } }
      @keyframes slideUp { from { opacity:0; transform:translateY(32px) } to { opacity:1; transform:translateY(0) } }
      @keyframes popIn   { 0%{transform:scale(0.82);opacity:0} 70%{transform:scale(1.04)} 100%{transform:scale(1);opacity:1} }
      @keyframes fadeOut { to { opacity:0; pointer-events:none } }
      @keyframes cardIn  { from{opacity:0;transform:scale(0.94) translateY(8px)} to{opacity:1;transform:scale(1) translateY(0)} }

      .anim-fade-in  { animation: fadeIn  0.35s ease both; }
      .anim-slide-up { animation: slideUp 0.4s cubic-bezier(.34,1.4,.64,1) both; }
      .anim-pop-in   { animation: popIn   0.4s cubic-bezier(.34,1.4,.64,1) both; }
      .anim-card-in  { animation: cardIn  0.3s ease both; }
    `}</style>
  );
}
